export default "__VITE_ASSET__D40Inubg__"